import React from "react";
import { CryptoMaterialCard as Details } from "../../../common";
import styles from "./cryptoAsset.module.scss";
const Summary = ({ material }) => {
    return (React.createElement(React.Fragment, null,
        material.format,
        React.createElement("div", { className: styles["secondary-text"] },
            "Size: ",
            material.size,
            " bits")));
};
export default { Details, Summary };
//# sourceMappingURL=Material.js.map